var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('h1',{staticClass:"products-page-title"},[_vm._v("Products page")]),_c('product-list',{staticClass:"product-list"}),(_vm.networkOnLine)?_c('add-product'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }